import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=aed9553a&scoped=true&"
import script from "./setting.vue?vue&type=script&lang=js&"
export * from "./setting.vue?vue&type=script&lang=js&"
import style0 from "./setting.vue?vue&type=style&index=0&id=aed9553a&prod&lang=scss&"
import style1 from "./setting.vue?vue&type=style&index=1&id=aed9553a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed9553a",
  null
  
)

export default component.exports